import React, { useEffect, useState } from "react";

const calculateTimeLeft = (targetYear) => {
	const now = new Date();

	if (targetYear <= now.getFullYear()) {
		return { days: 0, hours: 0, minutes: 0, seconds: 0 };
	}

	const targetDate = new Date(targetYear, 0, 1);
	const timeLeft = targetDate - now;
	const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
	const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
	const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
	return { days, hours, minutes, seconds };
};

const CountdownTimer = ({ targetyear = 2024 ,  onCountdownOver }) => {
	const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(targetyear));

	
	useEffect(() => {
		const timer = setInterval(() => {
			const updatedTimeLeft = calculateTimeLeft(targetyear);
			setTimeLeft(updatedTimeLeft);

			if (updatedTimeLeft.days === 0 && updatedTimeLeft.hours === 0 && updatedTimeLeft.minutes === 0 && updatedTimeLeft.seconds === 0) {
				clearInterval(timer);

				// Call the callback function when the countdown is over
				if (onCountdownOver) {
					onCountdownOver();
				}
			}
		}, 1000);

		return () => clearInterval(timer);
	}, [targetyear, onCountdownOver]);

	return (
		<div className="p-8 rounded-lg shadow-md text-center">
			<h3 className="text-xl mb-2 font-bold">Year ends in </h3>
			<div className="grid grid-cols-4 gap-4 text-[2rem] text-black mb-4">
				<div className="bg-gray-400 p-1 rounded-md">
					<div className="font-bold ">{timeLeft.days}</div>
					<div className="text-sm">Days</div>
				</div>
				<div className="bg-gray-400 p-1 rounded-md">
					<div className="font-bold">{timeLeft.hours}</div>
					<div className="text-sm">Hours</div>
				</div>
				<div className="bg-gray-400 p-1 rounded-md">
					<div className="font-bold">{timeLeft.minutes}</div>
					<div className="text-sm">Minutes</div>
				</div>
				<div className="bg-gray-400 p-1 rounded-md">
					<div className="font-bold">{timeLeft.seconds}</div>
					<div className="text-sm">Seconds</div>
				</div>
			</div>
		</div>
	);
};

export default CountdownTimer;
